import React from 'react'
import type { ReactElement } from 'react'
import AmazonPayButton from './AmazonPayButton'
import paypalExpress from './assets/paypal.png'
import shoppingBasket from './assets/shopping-basket-white.svg'
import { AmazonPayload } from './types/AmazonPayload'
import { DeliveryOption } from './types/DeliveryOptions'

type CheckoutOptionsProps = {
  amazonPayCheckout: boolean;
  amazonPayload: AmazonPayload;
  canCheckout: () => boolean;
  canExpressCheckout: () => boolean;
  deliveryOptionState: DeliveryOption
  onCheckout: (fullPath: string) => void;
  paypalExpressCheckout: boolean;
  railsEnv: string
}

type CheckoutPath = '/checkout';

type PaypalCheckoutPath = '/checkout/payment?paypal_express=1';

type EitherCheckoutPath = CheckoutPath | PaypalCheckoutPath;

const CheckoutOptions = ({
  amazonPayCheckout, amazonPayload, canCheckout, canExpressCheckout, deliveryOptionState, onCheckout, paypalExpressCheckout, railsEnv
}: CheckoutOptionsProps):
ReactElement => {
  function pathIfValid<Path extends EitherCheckoutPath> (path: Path): Path | null {
    if (canCheckout()) return path
    return null
  }

  const getPath = (express: boolean): EitherCheckoutPath => {
    if (express) {
      return '/checkout/payment?paypal_express=1'
    }
    return '/checkout'
  }

  const progressToCheckout = (express: boolean): void => {
    const path = getPath(express)
    const fullPath = pathIfValid(path)

    if (fullPath) {
      onCheckout(fullPath)
    }
  }

  return (
    <div className="checkout-options">
      {
        amazonPayCheckout && amazonPayload && canExpressCheckout() &&
        <AmazonPayButton amazonPayload={amazonPayload} canCheckout={canCheckout()} deliveryOptionState={deliveryOptionState} railsEnv={railsEnv} />
      }
      {
        paypalExpressCheckout && canExpressCheckout() &&
        <div className="paypal-checkout">
          <a
            onClick={(): void => { progressToCheckout(true) }}
            className="checkoutSubmit click-track paypal-link accessible-focus"
            data-event-category="PayPal Express"
            data-event-action="Choose Payment Method"
            data-event-label="N/A"
            data-event-value="12"
            title="Express checkout with PayPal"
            data-disabled={!canCheckout()}
            >
            <img src={paypalExpress} alt="Express Checkout with PayPal" loading="lazy" height="54" />
          </a>
        </div>
      }
      <div className="standard-checkout" >
        <a onClick={(): void => { progressToCheckout(false) }} className="checkoutSubmit standard-checkout-button checkout-link accessible-focus" title="Secure Checkout" data-disabled={!canCheckout()} aria-disabled={!canCheckout()}>
          Go to Checkout
        <img
            alt=""
            className="checkout-icon"
            aria-hidden="true"
            loading="lazy"
            width="20"
            height="15"
            src={shoppingBasket}
          />
        </a>
      </div>
    </div>
  )
}

export default CheckoutOptions
